import React,{useRef, useEffect} from "react";
import { useLocation } from "react-router-dom";
import "./home.css";
import Topbar from "../../components/Topbar/Topbar";
import Main from "../../components/Main/Main";
import Intro from "../../components/intro/Intro";
import Services from "../../components/Services/Services";
import Process from "../../components/Process/Process";
import Footer from "../../components/Footer/Footer";
import Casestudy from "../../components/CaseStudy/Casestudy";

export default function Home(){
    const location = useLocation();
    const processRef=useRef(null);
    const servicesRef=useRef(null);
    const testsRef=useRef(null);

    useEffect(()=>{
        processRef.current=document.querySelector('.process-container');

        servicesRef.current=document.querySelector(".service-container");
        
        testsRef.current=document.querySelector('.client-container');
    },[location]);

    return(
        <>
            <Topbar processRef={processRef} servicesRef={servicesRef} testsRef={testsRef}/>
            <div className="home-container">
                <Main/>
                <Intro/>
                <Services/>
                <Process/>
                <Casestudy/>
                <Footer servicesRef={servicesRef}/>
            </div>
        </>
    )
}